import { createAction, props } from '@ngrx/store';
import { Ratio, RatioCreate } from '../../models/ratio.model';

// Load Ratios
export const loadRatios = createAction(
  '[Ratios] Load Ratios',
  props<{ stockId: string; filters?: any }>()
);
export const loadRatiosSuccess = createAction(
  '[Ratios] Load Ratios Success',
  props<{ ratios: Ratio[] }>()
);
export const loadRatiosFailure = createAction(
  '[Ratios] Load Ratios Failure',
  props<{ error: any }>()
);

// Load Single Ratio
export const loadRatio = createAction('[Ratios] Load Ratio', props<{ id: string }>());
export const loadRatioSuccess = createAction(
  '[Ratios] Load Ratio Success',
  props<{ ratio: Ratio }>()
);
export const loadRatioFailure = createAction(
  '[Ratios] Load Ratio Failure',
  props<{ error: any }>()
);

// Create Ratio
export const createRatio = createAction('[Ratios] Create Ratio', props<{ ratio: RatioCreate }>());
export const createRatioSuccess = createAction(
  '[Ratios] Create Ratio Success',
  props<{ ratio: RatioCreate }>()
);
export const createRatioFailure = createAction(
  '[Ratios] Create Ratio Failure',
  props<{ error: any }>()
);

// Update Ratio
export const updateRatio = createAction(
  '[Ratios] Update Ratio',
  props<{ id: string; ratio: RatioCreate }>()
);
export const updateRatioSuccess = createAction(
  '[Ratios] Update Ratio Success',
  props<{ ratio: Ratio }>()
);
export const updateRatioFailure = createAction(
  '[Ratios] Update Ratio Failure',
  props<{ error: any }>()
);

// Delete Ratio
export const deleteRatio = createAction('[Ratios] Delete Ratio', props<{ id: string }>());
export const deleteRatioSuccess = createAction(
  '[Ratios] Delete Ratio Success',
  props<{ id: string }>()
);
export const deleteRatioFailure = createAction(
  '[Ratios] Delete Ratio Failure',
  props<{ error: any }>()
);
